/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  app.BaseTemplatedView = app.View.extend({
    el: '',
    template: false,
    templateId: '',
    /**
     * @inheritDoc
     */
    run: function (options) {
      if (options.templateId) {
        this.templateId = options.templateId;
      }
      if (this.templateId) {
        this.template = app.helpers.TemplateHelper.getTemplate(this.templateId);
      }
      this.listenTo(this.model, 'change', this.render);
    }
  });
})();

}.call(window));